import React from "react";

// Img
import kebabMenuCircle from "../../../assets/svg/action/kebab-menu-circle.svg";

export default function KebabCircleButton(props) {
  return (
    <img
      src={kebabMenuCircle}
      alt="kebab menu circle"
      {...props}
      style={{ width: "40px", cursor: "pointer", ...props.style }}
    />
  );
}
